export enum CookieKeys {
  METADATA = "Metadata-url",
  NEW_USER = "New-user-from",
}
